import './buildings.css';
import classNames from 'classnames';        
function Buildings({ isDay }) {


  return (
    <svg className="buildings" width="586" height="502" viewBox="0 0 586 502" preserveAspectRatio="xMidYMax meet" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="493" width="586" height="9" fill="#C4C4C4"/>
    <path d="M377 493V219.363H389.572V163.973H396.11V136.041H403.15V127.52H409.185V72.1294L421.254 57.9268L432.821 72.1294V127.52H439.358V136.041H446.902V163.973H453.439V219.363H464V493H434.832H406.671H377Z" className={classNames("empire-state-building", {
      "night": !isDay
    })}/>
    <path d="M406.671 219.363V493M406.671 219.363H389.572M406.671 219.363V163.973H396.11M406.671 493H377V219.363H389.572M406.671 493H434.832M389.572 219.363V163.973H396.11M396.11 163.973V136.041H403.15M434.832 493V219.363M434.832 493H464V219.363H453.439M434.832 219.363V163.973H446.902M434.832 219.363H453.439M453.439 219.363V163.973H446.902M446.902 163.973V136.041H439.358M439.358 136.041V127.52H432.821M439.358 136.041H403.15M403.15 136.041V127.52H409.185M409.185 127.52V72.1294M409.185 127.52H432.821M409.185 72.1294H432.821M409.185 72.1294L421.254 57.9268M432.821 72.1294V127.52M432.821 72.1294L421.254 57.9268M421.254 57.9268V21" stroke="black"/>
    <rect x="401.5" y="144.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="161.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="161.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="178.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="195.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="212.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="229.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="246.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="263.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="280.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="297.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="314.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="331.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="348.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="365.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="382.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="399.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="416.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="433.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="450.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="467.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="467.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="450.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="433.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="416.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="399.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="382.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="365.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="348.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="331.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="314.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="297.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="280.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="263.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="246.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="229.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="212.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="195.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="178.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="412.5" y="144.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="423.5" y="144.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="434.5" y="144.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="178.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="178.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="195.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="229.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="258.5" y="237.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="229.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="246.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="263.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="280.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="297.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="314.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="331.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="348.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="365.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="382.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="399.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="416.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="433.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="450.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="441.5" y="467.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="229.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="246.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="263.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="280.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="297.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="314.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="331.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="348.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="365.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="382.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="399.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="416.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="433.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="450.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="452.5" y="467.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="246.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="263.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="280.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="297.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="314.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="331.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="348.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="365.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="382.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="399.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="416.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="433.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="450.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="394.5" y="467.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="467.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="229.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="246.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="263.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="280.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="297.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="314.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="331.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })}stroke="black"/>
    <rect x="381.5" y="348.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="365.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="382.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="399.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })}stroke="black"/>
    <rect x="381.5" y="416.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="433.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="381.5" y="450.5" width="6" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M448 195.5V205.5H442V195.5H448Z" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M128 493H25V486.987V148.268V140.752L51.9634 136.994V119.707L56.2775 117.202L64.3665 115.699L71.9162 114.697V90.6457L70.2984 89.1425V82.6287L72.4555 81.1255H77.5785H82.7016L84.3194 82.6287V89.1425L82.1623 90.6457V114.697H86.4764L94.0262 115.699L101.576 117.202L104.812 119.707V137.201L128 140.752V486.987V493Z" className={classNames("freedom-tower-outside", {
      "night": !isDay
    })}/>
    <path d="M78.9267 133.236L25 486.987M78.9267 133.236L128 486.987M78.9267 133.236L51.9634 136.994M78.9267 133.236L104.812 137.201M25 486.987V493H128V486.987M25 486.987V148.268V140.752L51.9634 136.994M128 486.987V140.752L104.812 137.201M51.9634 136.994V119.707L56.2775 117.202L64.3665 115.699L71.9162 114.697M71.9162 114.697V90.6457M71.9162 114.697H82.1623M104.812 137.201V119.707L101.576 117.202L94.0262 115.699L86.4764 114.697H82.1623M71.9162 90.6457H82.1623M71.9162 90.6457L70.2984 89.1426V82.6287L72.4555 81.1255H77.5785M82.1623 90.6457V114.697M82.1623 90.6457L84.3194 89.1426V82.6287L82.7016 81.1255H77.5785M77.5785 22V81.1255" stroke="black"/>
    <path d="M79.5 132L129 492.5H25L79.5 132Z"  stroke="black" className={classNames("freedom-tower-inside", {
      "night": !isDay
    })}/>   
    <line x1="77" y1="152.5" x2="81" y2="152.5" className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="76" y1="164.5" x2="83" y2="164.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="74" y1="176.5" x2="85" y2="176.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="73" y1="188.5" x2="85" y2="188.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="71" y1="200.5" x2="87" y2="200.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="69" y1="212.5" x2="89" y2="212.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="67" y1="224.5" x2="91" y2="224.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="65" y1="236.5" x2="93" y2="236.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="63" y1="248.5" x2="94" y2="248.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="61" y1="260.5" x2="96" y2="260.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="59" y1="272.5" x2="98" y2="272.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="58" y1="284.5" x2="99" y2="284.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="56" y1="296.5" x2="101" y2="296.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="54" y1="308.5" x2="102" y2="308.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="52" y1="320.5" x2="104" y2="320.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="50" y1="332.5" x2="106" y2="332.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="48" y1="344.5" x2="108" y2="344.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="47" y1="356.5" x2="109" y2="356.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="45" y1="368.5" x2="110" y2="368.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="43" y1="380.5" x2="113" y2="380.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="41" y1="392.5" x2="114" y2="392.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="39" y1="404.5" x2="116" y2="404.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="37" y1="416.5" x2="117" y2="416.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="36" y1="428.5" x2="119" y2="428.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="34" y1="440.5" x2="121" y2="440.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="32" y1="452.5" x2="122" y2="452.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="30" y1="464.5" x2="124" y2="464.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="29" y1="476.5" x2="126" y2="476.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
    <line x1="27" y1="488.5" x2="127" y2="488.5"  className={classNames("freedom-tower-line", {
      "night": !isDay
    })}/>
   
    {/* {!isDay && ( */}
      <g filter="url(#filter0_d_206_2)">
        <line x1="77" y1="81" x2="77" y2="22"  className={classNames("freedom-tower-atenna", {
      "night": !isDay
    })} stroke-width="4"/>
      </g>
 
    <path d="M539.905 346.5H527.389V490.5H578L574.449 334V156H539.905V346.5Z" className={classNames("background-buildings", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M246.538 313.384H225V492H380.199V255.031H342.825V264.282H338.391V334.021H328.255V341.849H303.55V195.255H295.948V174.618H285.179V149H272.51V174.618H261.741V195.255H254.773V341.849H246.538V313.384Z" className={classNames("background-buildings", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="262.548" y="206.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="289.583" y="237.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="262.548" y="285.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="289.583" y="333.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="348.658" y="302.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="230.506" y="393.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="285.577" y="470.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="259.544" y="426.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="269.557" y="367.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="495.848" y="405.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="474.82" y="362.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="505.86" y="317.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="488.838" y="287.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="563.935" y="217.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="545.912" y="173.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="365.68" y="268.5" width="6.00901" height="10" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M375.5 364V493H306V364H302V353H380V364H375.5Z" className={classNames("small-red-building-bricks", {
      "night": !isDay
    })}/>
    <path d="M375.5 364V493H306V364M375.5 364H306M375.5 364H380V353H302V364H306" stroke="black"/>
    <path d="M380 364V353H302V364H380Z" stroke="black" className={classNames("small-red-building-top", {
      "night": !isDay
    })}/>
    <rect x="311" y="443" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="327" y="466" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="359" y="466" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="343" y="443" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="359" y="420" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="327" y="420" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="311" y="397" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="343" y="397" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="359" y="374" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="327" y="373" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="311" y="466" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="343" y="466" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="327" y="443" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="359" y="443" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="343" y="420" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="311" y="420" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="327" y="397" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="359" y="397" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="343" y="373" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="311" y="373" width="9" height="14" className={classNames("black-yellow-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 291.5H129V298.5H224.5V291.5Z" stroke="black"/>
    <path d="M224.5 298.5H129V305.5H224.5V298.5Z" stroke="black"/>
    <path d="M224.5 305.5H129V312.5H224.5V305.5Z" stroke="black"/>
    <path d="M224.5 284.5H129V291.5H224.5V284.5Z" stroke="black"/>
    <path d="M224.5 280H129V296.5V492H224.5V280Z"  className={classNames("midsized-grey-building", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 431.5H129V438.5H224.5V431.5Z" stroke="black"/>
    <path d="M224.5 368.5H129V375.5H224.5V368.5Z" stroke="black"/>
    <path d="M224.5 305.5H129V312.5H224.5V305.5Z"  className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 312.5H129V319.5H224.5V312.5Z" stroke="black"/>
    <path d="M224.5 319.5H129V326.5H224.5V319.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 326.5H129V333.5H224.5V326.5Z" stroke="black"/>
    <path d="M224.5 333.5H129V340.5H224.5V333.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 340.5H129V347.5H224.5V340.5Z" stroke="black"/>
    <path d="M224.5 347.5H129V354.5H224.5V347.5Z"className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 354.5H129V361.5H224.5V354.5Z" stroke="black"/>
    <path d="M224.5 361.5H129V368.5H224.5V361.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 431.5H129V438.5H224.5V431.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 445.5H129V452.5H224.5V445.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 452.5H129V459.5H224.5V452.5Z" stroke="black"/>
    <path d="M224.5 459.5H129V466.5H224.5V459.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 466.5H129V473.5H224.5V466.5Z" stroke="black"/>
    <path d="M224.5 473.5H129V480.5H224.5V473.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 375.5H129V382.5H224.5V375.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 382.5H129V389.5H224.5V382.5Z" stroke="black"/>
    <path d="M224.5 389.5H129V396.5H224.5V389.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 396.5H129V403.5H224.5V396.5Z" stroke="black"/>
    <path d="M224.5 403.5H129V410.5H224.5V403.5Z"  className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 410.5H129V417.5H224.5V410.5Z" stroke="black"/>
    <path d="M224.5 417.5H129V424.5H224.5V417.5Z" className={classNames("midsized-grey-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M224.5 424.5H129V431.5H224.5V424.5Z" stroke="black"/>
    <path d="M224.5 424.5H129V431.5H224.5V424.5Z" stroke="black"/>
    <path d="M305 423.5V492L298 491.956L284 491.867L278.5 491.832L253.5 491.674L248.5 491.642L226 491.5L226.5 422H229L228.5 402H231V382.5L240.5 322V313H243V322L251.676 382.5L251.5 402.5H254L253.5 422L265.5 403.5V396.5H263.5V395.5H265.5V393H267.5V395.5H269.5V396.5H267.5V403.5L278.5 421V402H281.5V382.5L290 322V313H292V322L301 384V402H303V423.5H305Z" className={classNames("church-building", {
      "night": !isDay
    })}/>
    <path d="M248.5 491.642L226 491.5L226.5 422H229L228.5 402H231V382.5L240.5 322V313H243V322L251.676 382.5L251.5 402.5H254L253.5 422L265.5 403.5V396.5H263.5V395.5H265.5V393H267.5V395.5H269.5V396.5H267.5V403.5L278.5 421V402H281.5V382.5L290 322V313H292V322L301 384V402H303V423.5H305V492L298 491.956L284 491.867L278.5 491.832L253.5 491.674L248.5 491.642ZM248.5 491.642L234 491.5" stroke="black"/>
    <path d="M258 473.5V491.5H275V473.5L266.5 463L258 473.5Z"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M239.478 397.5H237C236.448 397.5 236 397.052 236 396.5V374.236C236 374.081 236.036 373.927 236.106 373.788L237.106 371.789C237.474 371.052 238.526 371.052 238.894 371.789L239.899 373.799C239.966 373.931 240.002 374.077 240.005 374.225L240.478 396.479C240.49 397.039 240.039 397.5 239.478 397.5Z"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M245.978 397.5H243.5C242.948 397.5 242.5 397.052 242.5 396.5V374.236C242.5 374.081 242.536 373.927 242.606 373.788L243.606 371.789C243.974 371.052 245.026 371.052 245.394 371.789L246.399 373.799C246.466 373.931 246.502 374.077 246.505 374.225L246.978 396.479C246.99 397.039 246.539 397.5 245.978 397.5Z"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M288.978 397.5H286.5C285.948 397.5 285.5 397.052 285.5 396.5V374.236C285.5 374.081 285.536 373.927 285.606 373.788L286.606 371.789C286.974 371.052 288.026 371.052 288.394 371.789L289.399 373.799C289.466 373.931 289.502 374.077 289.505 374.225L289.978 396.479C289.99 397.039 289.539 397.5 288.978 397.5Z" className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M295.978 397.5H293.5C292.948 397.5 292.5 397.052 292.5 396.5V374.236C292.5 374.081 292.536 373.927 292.606 373.788L293.606 371.789C293.974 371.052 295.026 371.052 295.394 371.789L296.399 373.799C296.466 373.931 296.502 374.077 296.505 374.225L296.978 396.479C296.99 397.039 296.539 397.5 295.978 397.5Z"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M238 478.5V491.5H245V478.5L241.5 472L238 478.5Z" className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M287.5 478.5V491.5H294.5V478.5L291 472L287.5 478.5Z"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M295 450H287L287.5 435.5L291 430.5L294.5 435.5L295 450Z"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M244.5 449.5H236.5L237 435L240.5 430L244 435L244.5 449.5Z"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <circle cx="266.5" cy="434" r="8.5"  className={classNames("church-building-windows", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M266.5 393V402.947V403.5" stroke="black"/>
    <path d="M585 308.415V432.647V493H526V230H543.911V254.67H558.134V278.459H572.884V308.415H585Z" className={classNames("tetris-building", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="323.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="342.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })}stroke="black"/>
    <rect x="573.5" y="360.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="398.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="436.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="455.5" width="6" height="10" fill="#010101" stroke="black"/>
    <rect x="573.5" y="379.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="417.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="455.5" width="6" height="10"className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="573.5" y="474.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="285.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="304.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="323.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="342.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="360.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="379.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="398.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="436.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="455.5" width="6" height="10" fill="#010101" stroke="black"/>
    <rect x="532.5" y="417.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="455.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="474.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="265.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="265.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="285.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="304.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="323.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="342.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="360.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="398.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="436.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="455.5" width="6" height="10" fill="#010101" stroke="black"/>
    <rect x="546.5" y="379.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="417.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="455.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="546.5" y="474.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="285.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="304.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="323.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="342.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="360.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="398.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="436.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="455.5" width="6" height="10" fill="#010101" stroke="black"/>
    <rect x="560.5" y="379.5" width="6" height="10"className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="417.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="455.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="560.5" y="474.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <rect x="532.5" y="239.5" width="6" height="10" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M520 186L466 234V493.5H526V186H520Z" className={classNames("polygon-building", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 248H466V254H526V248Z" stroke="black"/>
    <path d="M466 248V243H526V248H466Z"  className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 254H466V260H526V254Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 272H466V278H526V272Z" stroke="black"/>
    <path d="M526 278H466V284H526V278Z"  className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 284H466V290H526V284Z" stroke="black"/>
    <path d="M526 290H466V296H526V290Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 302H466V308H526V302Z" stroke="black"/>
    <path d="M526 308H466V314H526V308Z" stroke="black"/>
    <path d="M526 314H466V320H526V314Z"  className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M466 296H526M466 296C489.431 296 502.569 296 526 296V302H466V296Z" stroke="black"/>
    <path d="M526 302H466V308H526V302Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })}/>
    <path d="M466 302H526M466 302C489.431 302 502.569 302 526 302V308H466V302Z" stroke="black"/>
    <path d="M526 320H466V326H526V320Z" stroke="black"/>
    <path d="M526 326H466V332H526V326Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 332H466V338H526V332Z" stroke="black"/>
    <path d="M526 338H466V344H526V338Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 344H466V350H526V344Z" stroke="black"/>
    <path d="M526 350H466V356H526V350Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 356H466V362H526V356Z" stroke="black"/>
    <path d="M526 362H466V368H526V362Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 368H466V374H526V368Z" stroke="black"/>
    <path d="M526 260H466V266H526V260Z" stroke="black"/>
    <path d="M526 266H466V272H526V266Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })}stroke="black"/>
    <path d="M526 374H466V380H526V374Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 380H466V386H526V380Z" stroke="black"/>
    <path d="M526 398H466V404H526V398Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 386H466V392H526V386Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 410H466V416H526V410Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 416H466V422H526V416Z" stroke="black"/>
    <path d="M526 422H466V428H526V422Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 428H466V434H526V428Z" stroke="black"/>
    <path d="M526 434H466V440H526V434Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 440H466V446H526V440Z" stroke="black"/>
    <path d="M526 446H466V452H526V446Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 452H466V458H526V452Z" stroke="black"/>
    <path d="M526 458H466V464H526V458Z" stroke="black"/>
    <path d="M526 458H466V464H526V458Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 464H466V470H526V464Z" stroke="black"/>
    <path d="M526 470H466V476H526V470Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <path d="M526 476H466V482H526V476Z" stroke="black"/>
    <path d="M526 482H466V488H526V482Z" className={classNames("black-yellow-windows ", {
      "night": !isDay
    })} stroke="black"/>
    <defs>
      {/* Animate filter when it's night time! */}
    <filter id="filter0_d_206_2" x="53" y="0" width="48" height="103" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="11">
      <animate attributeName="stdDeviation" values="6;12;6" dur="3s" repeatCount="indefinite"/>
    </feGaussianBlur>
    
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_206_2"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_206_2" result="shape"/>
    </filter>
    </defs>
    </svg>

  );
}

export default Buildings;
